/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";

import "./story-headline.module.css";

export const StoryHeadline = ({ headline, headlineWhite }) => {
  const color = headlineWhite ? "colored-headline headline" : "headline";
  return (
    <h1 data-testid="headline" styleName={`${color}`}>
      <bdi dangerouslySetInnerHTML={{ __html: headline }} />
    </h1>
  );
};

StoryHeadline.propTypes = {
  headline: PropTypes.string.isRequired,
  headlineWhite: PropTypes.string
};
